var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{class:_vm.likeButtonClass,attrs:{"href":_vm.loginUrlWithPassback},on:{"click":_vm.toggleLikeStatus}},[_c('span',{staticClass:"ba f4 pa2 br2 b--black-10 bg-animate hover-bg-near-white cursor"},[_c('span',{staticClass:"f3"},[_vm._v("♥")]),_vm._v(" "),_c('span',{staticClass:"silver"},[_vm._v(_vm._s(_vm.likeCount))])])])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-51f8d85c","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/main/frontend/vue/js/modules/pro/project/components/ProProjectReactionForm.vue
// module id = null
// module chunks = 